import React from 'react';

import Box from 'components/Box';
import Hide from 'components/Hide';
import { IdealistLogo } from 'components/Logo';
import NoAmp from 'containers/NoAmp';
import SearchInputsContainer from 'containers/SearchInputsContainer';
import StaffSearchInputsContainer from 'containers/StaffSearchInputsContainer';
import { colors, gutterWidth } from 'theme';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const SearchMenu = ({
  onSearch,
  defaultSearchType,
  navSection,
  qaId = 'search-menu',
  inPageHeader,
  searchFrom,
  searchMode,
}: {
  onSearch: (arg0: {
    query?: string;
    type?: string;
    searchType?: string;
  }) => void;
  defaultSearchType?: DefaultSearchType;
  navSection: 'MAIN' | 'STAFF';
  qaId?: string;
  inPageHeader?: boolean;
  searchFrom?: string;
  searchMode?: boolean;
}) => {
  const isStaff = navSection === 'STAFF';
  const SearchInputsContainerComponent = isStaff
    ? StaffSearchInputsContainer
    : SearchInputsContainer;

  return (
    <NoAmp>
      <Box
        data-qa-id={qaId}
        classes={['flex', 'align-center']}
        position="relative"
        width="100%"
        bg={inPageHeader && 'white'}
        pb={inPageHeader && [gutterWidth / 2, null, null, 16]}
        pt={inPageHeader && [gutterWidth / 2 + 60, null, null, 16]}
        px={inPageHeader && gutterWidth / 2}
        height={inPageHeader && '100%'}
        borderTop={inPageHeader && `1px solid ${colors.platinum}`}
      >
        {inPageHeader && (
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; xs: true; sm: true; md:... Remove this comment to see the full error message
          <Hide xs sm md flex="0 0 auto">
            <Box height="100%" mr={[24, null, null, null, 40]}>
              <Box
                component="a"
                href={isStaff ? '/staff' : '/'}
                title={`Idealist${isStaff ? ' Staff' : ''}`}
                data-qa-id="header-logo-link"
                display="block"
                height="100%"
              >
                <IdealistLogo
                  height={[36, null, null, null, 48]}
                  showStaffMarker={isStaff}
                />
              </Box>
            </Box>
          </Hide>
        )}
        <Box flex="1 1 auto" width="100%" height={inPageHeader && '100%'}>
          <SearchInputsContainerComponent
            searchMode={searchMode}
            onSearch={onSearch}
            searchSection={isStaff ? 'STAFF' : 'MAIN'}
            inPageHeader={inPageHeader}
            isStaff={isStaff}
            searchFrom={searchFrom}
            defaultSearchType={defaultSearchType}
          />
        </Box>
      </Box>
    </NoAmp>
  );
};

export default SearchMenu;
